import React from 'react';
import { SectionHeader } from './ui/SectionHeader';
import { CtaBlock } from './ui/CtaBlock';
import { PRODUCT_NAME, tomos } from '../data/content';
export function SolutionSection() {
  return <section aria-labelledby="solucion" className="border-b border-crema bg-blanco" data-id="element-129" data-mp="3o9trxz6mahzz">
      <div className="mx-auto max-w-3xl px-4 py-6 sm:py-9" data-id="element-130" data-mp="3jah4bc7x96wc">
        <SectionHeader id="solucion" eyebrowTone="petroleo" eyebrow="La solución que estabas buscando — un sistema 6 en 1" title="6 tomos en un solo sistema, creados para ayudarte a reorganizar diferentes áreas de tu vida paso a paso." data-id="element-131" data-mp="3j8w8lj9vfhww" />
        <p className="mt-2 text-center text-sm font-extrabold text-terracota sm:text-base" data-id="element-132" data-mp="atw3iipg1k4b">✨ {PRODUCT_NAME}</p>
        <p className="mx-auto mt-1 max-w-2xl text-center text-sm leading-snug text-azul/80" data-id="element-133" data-mp="5w2y3rvysu53">
          No es simplemente otro ebook de desarrollo personal. Es una ruta práctica
          que organiza herramientas de claridad, hábitos, propósito, relaciones y
          planificación para ayudarte a comprender dónde estás, decidir qué querés
          cambiar y convertirlo en acciones concretas.
        </p>

        <ol className="mt-4 grid gap-2 sm:grid-cols-2" data-id="element-134" data-mp="3bbt8rcn75h6e">
          {tomos.map((tomo, i) => <li key={tomo.title} className="flex gap-2.5 rounded-xl border border-crema bg-crema/40 p-3" data-id="element-135" data-mp="3f9zechcatqpq" data-mpi={i}>
              <span className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-lg bg-petroleo font-serif text-lg font-bold text-dorado" data-id="element-136" data-mp="3k8alulf4fp4s">
                {i + 1}
              </span>
              <div data-id="element-137" data-mp="3u6gk8t1pyd4w">
                <p className="text-[0.7rem] font-bold uppercase text-terracota" data-id="element-138" data-mp="2tvnyer214oj">Tomo {i + 1}</p>
                <h3 className="text-sm font-extrabold leading-tight text-azul" data-id="element-139" data-mp="6vh90ndqsp9t">{tomo.title}</h3>
                <p className="mt-0.5 text-[0.8rem] leading-snug text-azul/80 sm:text-sm" data-id="element-140" data-mp="bulizg8hqr17">{tomo.desc}</p>
              </div>
            </li>)}
        </ol>

        <CtaBlock note="" data-id="element-141" data-mp="gu6flk06unar" />
      </div>
    </section>;
}